export class Range {
  start: any;
  end: any;

  constructor(data: any) {
    this.start = data.start;
    this.end = data.end;
  }
}
